<div class="vendor-info-container">
  <div class="card-container">
    <!-- About card -->
    <div class="col">
      <emerald-card>
        <div class="content-container">
          <div class="header-row">
            <div class="heading-title">{{ vendorProfileInfo.labelAbout }}</div>
            <emerald-icon
              [icon]="'edit'"
              [type]="'outlined'"
              [variant]="'symbol'"
              (click)="opened = true; openAboutDialog()"
            />
          </div>
          <div class="details">
            <ng-container>
              <p *ngFor="let detail of aboutDetails; trackBy: trackByKey">
                <strong>{{ detail.label }}</strong>
                <span>{{ about[detail.key] || "-" }}</span>
              </p>
            </ng-container>
          </div>
        </div>
      </emerald-card>
    </div>

    <!-- Contact cards -->
    <div
      class="col"
      *ngFor="
        let contact of vendorContact;
        let i = index;
        trackBy: trackContact
      "
    >
      <emerald-card>
        <div class="content-container">
          <div class="header-row">
            <div class="heading-title">{{ headerText.ContactInformation }}</div>
            <emerald-icon
              [icon]="'edit'"
              [type]="'outlined'"
              [variant]="'symbol'"
              (click)="openedCi = true; openContactDialog(i)"
            />
          </div>
          <div class="details">
            <ng-container>
              <p *ngFor="let detail of contactDetails">
                <strong>{{ detail.label }}</strong>
                <span>{{ contact[detail.key] || "-" }}</span>
              </p>
            </ng-container>
          </div>
        </div>
      </emerald-card>
    </div>
  </div>

  <emerald-modal
    [opened]="opened"
    [headerText]="headerText.ModifyVendorInformation"
    [areButtonsStacked]="true"
    [enableFullscreen]="true"
    [widthInRem]="58"
    [hasCloseIcon]="true"
    [closeOnOutsideClick]="true"
    [titleId]="'titleId'"
    [contentId]="'contentId'"
    (onDismiss)="opened = false"
  >
    <form [formGroup]="aboutForm" novalidate>
      <div class="form-vertical">
        <div class="field" *ngFor="let d of aboutDetails; trackBy: trackByKey">
          <emerald-input
            *ngIf="
              getFieldType(d.key) === 'text' || getFieldType(d.key) === 'email'
            "
            [label]="d.label"
            [outlined]="true"
            [value]="about[d.key]"
            [isValid]="isFieldValid(aboutForm, d.key)"
            [errorText]="getFieldError(aboutForm, d.key)"
            [formControlName]="d.key"
            [disabled]="d.key === vendorProfileInfo.keyVendorId"
          ></emerald-input>
          <emerald-datepicker
            *ngIf="getFieldType(d.key) === 'date'"
            [label]="d.label"
            [isOutlined]="true"
            [forceRefresh]="true"
            [keepInvalid]="isFieldValid(aboutForm, d.key)"
            [required]="true"
            [formControlName]="d.key"
            (keydown)="preventInvalidKeyPress($event)"
          ></emerald-datepicker>
        </div>
      </div>
    </form>
    <ng-container actions>
      <!-- alert modal actions -->
      <emerald-button
        [label]="'Cancel'"
        [type]="'Secondary'"
        (onClick)="opened = false"
      ></emerald-button>
      <emerald-button
        [label]="'Submit'"
        [type]="'Primary'"
        (onClick)="saveAboutDialog()"
        [disabled]="aboutForm.invalid"
      ></emerald-button>
    </ng-container>
  </emerald-modal>

  <emerald-modal
    [opened]="openedCi"
    [headerText]="headerText.ModifyContactInformation"
    [areButtonsStacked]="true"
    [enableFullscreen]="true"
    [widthInRem]="58"
    [hasCloseIcon]="true"
    [closeOnOutsideClick]="true"
    [titleId]="'titleId'"
    [contentId]="'contentId'"
    (onDismiss)="openedCi = false"
  >
    <form [formGroup]="contactForm" novalidate>
      <div class="form-vertical">
        <div
          class="field"
          *ngFor="let f of contactDetails; trackBy: trackByKey"
        >
          <emerald-input
            *ngIf="
              getFieldType(f.key) === 'text' || getFieldType(f.key) === 'email'
            "
            [label]="f.label"
            [outlined]="true"
            [value]="contactForm.get(f.key)?.value"
            [isValid]="isFieldValid(contactForm, f.key)"
            [errorText]="getFieldError(contactForm, f.key)"
            [formControlName]="f.key"
          ></emerald-input>
          <emerald-input
            *ngIf="getFieldType(f.key) === 'number'"
            [label]="f.label"
            [outlined]="true"
            [value]="contactForm.get(f.key)?.value"
            [isValid]="isFieldValid(contactForm, f.key)"
            [errorText]="getFieldError(contactForm, f.key)"
            [formControlName]="f.key"
            [maxLength]="maxLengthTen"
            (input)="validate($event)"
          ></emerald-input>
        </div>
      </div>
    </form>
    <ng-container actions>
      <!-- alert modal actions -->
      <emerald-button
        [label]="'Cancel'"
        [type]="'Secondary'"
        (onClick)="openedCi = false"
      ></emerald-button>
      <emerald-button
        [label]="'Submit'"
        [type]="'Primary'"
        (onClick)="saveContactDialog()"
        [disabled]="contactForm.invalid"
      ></emerald-button>
    </ng-container>
  </emerald-modal>
</div>
